function cookiesByName(): Record<string, string> {
  const hash: Record<string, string> = {}

  Array.from(document.cookie.split(/;\s*/)).forEach((string) => {
    const nameAndValue = string.split('=')
    const name = nameAndValue[0]
    const value = nameAndValue[1]
    hash[name] = decodeURIComponent(value)
  })

  return hash
}

export function getCookie(name: string): string | undefined {
  return cookiesByName()[name]
}

export function deleteCookies(matches: (name: string) => boolean): void {
  const namesToDelete = Object.keys(cookiesByName()).filter(matches)

  if (namesToDelete.length === 0) {
    return
  }

  const hostParts = location.hostname.split('.')
  const domainAttributes = ['']
  for (let i = 0; i < hostParts.length - 1; i++) {
    domainAttributes.push(`; domain=.${hostParts.slice(i).join('.')}`)
  }

  for (const name of namesToDelete) {
    for (const domainAttribute of domainAttributes) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainAttribute}`
    }
  }
}

export function setCookie(name: string, value: string, { days }: { days: number }): void {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`
}
